module.exports = __webpack_public_path__ + "static/jfk-2a6b399f4f826d00ea975200eccaf0cb.png";